<template>
  <ButtonSquare
    :title="$t('general__view__planview')"
    :imgSource="iconPlanview"
    size="large"
    @clicked="handleClick"
  />
</template>

<script setup lang="ts">
import { useStore } from 'vuex'
import { computed } from 'vue'
import ButtonSquare from '@/components/general/buttons/ButtonSquare/ButtonSquare.vue'
import { MAPVIEW_PREFIX, PLANVIEW_PREFIX } from '@/store/module-prefixes'
import { setViewToPlanview } from '@/utils/views'
import { zoomToEntities } from '@/composables/useMapbox'
import iconPlanview from '@/assets/icon-planview.svg'

// Vuex store
const store = useStore()

// State
const selectedBuilding = computed(() => store.state[MAPVIEW_PREFIX].selectedBuilding)

// Action
function loadSensorData() {
  return store.dispatch(`${PLANVIEW_PREFIX}/loadSensorData`)
}

// Handle click event
async function handleClick() {
  setViewToPlanview()
  await loadSensorData()
  await new Promise((resolve) => setTimeout(resolve, 10))
  zoomToEntities([selectedBuilding.value.id])
}
</script>
